export default "__VITE_ASSET__01d75890__"